export default __webpack_public_path__ + "static/media/course-complete.3085480b.svg";